import ResultGlass from "./ResultGlass";

export {
  ResultGlassProps,
  ResultGlassState,
  ResultType,
  SharingType,
} from "./ResultGlass";
export default ResultGlass;
